import { useQuery } from '@tanstack/react-query';
import { Option, Price } from '../models';
import QueryKeys from '../utils/QueryKeys';

/**
 * The buyable options on a pricelist, with THIS school's prices.
 *
 * Prices are per-school, so the scope must be merged in: without `for_school` an option
 * carries every school's price row and prices[0] is whichever came back first — i.e. some
 * other school's price. hasPrice drops the rows a school never priced.
 */
export default function usePackageOptions(packageId, schoolId) {
  return useQuery(
    [QueryKeys.OPTIONS, packageId, schoolId],
    () => Option
      .includes(['image_types', 'prices'])
      .merge({ prices: Price.where({ for_school: schoolId, hasPrice: true }) })
      .where({ packageId })
      .order('abbreviation')
      .all()
      .then((res) => res.data || []),
    { enabled: !!(packageId && schoolId), placeholderData: [] },
  );
}
